import { logRealtime } from './realtime-logger.js';

type PusherConnection = {
  state: string;
  bind: (event: string, handler: () => void) => void;
  unbind: (event: string, handler: () => void) => void;
};

/** Wait until Pusher WS is connected before subscribing to private channels. */
export function waitForPusherConnected(
  connection: PusherConnection,
  timeoutMs = 15_000,
): Promise<void> {
  if (connection.state === 'connected') {
    return Promise.resolve();
  }

  return new Promise((resolve, reject) => {
    const onConnected = () => {
      clearTimeout(timer);
      connection.unbind('connected', onConnected);
      logRealtime('pusher', 'waitForConnected: ready', {
        state: connection.state,
      });
      resolve();
    };

    const timer = setTimeout(() => {
      connection.unbind('connected', onConnected);
      reject(
        new Error(
          `[Teo Widget] Pusher connection timeout (${timeoutMs}ms), state=${connection.state}`,
        ),
      );
    }, timeoutMs);

    connection.bind('connected', onConnected);
  });
}
